import { FormField } from "./enum";

export const FormFields = {
  [FormField.BIO]: {
    isRequired: false,
    name: "bio",
    placeholder: "form.placeholder.bio",
  },
};
